import { Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { styled } from '@mui/material/styles';

export const ActionButton = styled(Button)(({ theme }) => ({
  marginTop: 10,
  backgroundColor: theme.palette.dialog.primaryButton.background,
  height: 50,
  width: "100%",
  color: theme.palette.dialog.primaryButton.color,
  "&:hover": {
    backgroundColor: theme.palette.dialog.primaryButton.backgroundHover,
  }
}));

export const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  padding: "10px 15px",
  backgroundColor: theme.palette.dialog.title.background,
  color: theme.palette.dialog.title.color,
  overflowX: "hidden",
  borderRadius: "10px 10px 0 0"
}));

export const DialogContentRoot = styled(DialogContent)({
  padding: 1,
  backgroundColor: "white"
});

export const DialogActionRoot = styled(DialogActions)({
  padding: 0,
  backgroundColor: "white",
  borderRadius: "0 0 10px 10px",
  "& button": {
    borderRadius: "4px"
  }
});